export default function mapCartItem(cartItem) {
    const count = (cartItem.payload && cartItem.payload.count) || 1

    return {
        item_id: cartItem.payload ? cartItem.payload.product_id : cartItem.id,
        item_name: cartItem.title,
        item_category: cartItem.type,
        price: count ? cartItem.total / count : cartItem.total,
        quantity: count,
    }
}
